import { createSelector } from '@reduxjs/toolkit';
import { selectModel } from '../../store/selectors';

export const selectModelAssociationsState = createSelector(selectModel, (modelState) => modelState.modelAssociations);
export const selectModelAssociations = createSelector(selectModelAssociationsState, (listState) => listState.modelAssociations);
